import { FormattedMessage } from 'react-intl';

interface Redirection {
  companyCreationFromScratch?: boolean;
  partnerType?: string;
  partnerName?: string;
}

interface EmailConfirmationSubtitleProps {
  email: string;
  redirection: Redirection;
}

export function EmailConfirmationSubtitle({ email, redirection }: EmailConfirmationSubtitleProps) {
  if (redirection.companyCreationFromScratch) {
    return (
      <FormattedMessage
        id="confirmation-code.fr-full-cc.subtitle"
        values={{ email_address: email }}
      />
    );
  }

  if (redirection.partnerType === 'legal_tech' || redirection.partnerType === 'embed') {
    return (
      <FormattedMessage
        id="confirmation-code.subtitle"
        values={{ email_address: email, legal_tech_partner_name: redirection.partnerName }}
      />
    );
  }

  if (redirection.partnerType === 'accountant') {
    return (
      <FormattedMessage
        id="confirmation-code.accountant.subtitle"
        values={{ email_address: email }}
      />
    );
  }

  return null;
}
